<div v-if="comments.length > 0" class="tt-c-question__comments">
  <div class="tt-c-question">
    <div class="tt-c-question__icon-col">
      <tt-icon name="question" size="md" class="tt-c-question__icon"></tt-icon>
    </div>
    <div class="tt-c-question__body tt-u-spacing--md">
      <div class="tt-c-question__title" role="heading" :aria-level="heading.level" v-html="heading.text"></div>
      <div class="tt-c-question__byline tt-u-no-space">
        <span class="tt-c-question__byline-name">{{siteName}} </span>
        <span class="tt-c-question__badge tt-o-badge" v-html="$msg('commentsQuestion.storeBadge')"></span>
      </div>
    </div>
  </div>
  <div class="tt-c-question__answers">
    <div class="tt-c-question__comment-list">
      <tt-qa-comment v-for="(comment, index) in commentsForDisplay"
                     class="tt-c-question__comment"
                     :comment="comment" metaType="fd"
                     :truncateLength="truncateLength"
                     :truncateAllowance="truncateAllowance"
                     :order="index"
                     :key="comment.id"></tt-qa-comment>
    </div>
    <div v-if="showActions" class="tt-c-question__actions">
      <tt-button ref="expandComments" v-show="showExpand" type="toolbar" class="tt-c-question__actions-show" @click="expandComments"
                                                                              aria-expanded="false">
        <tt-icon name="options-expand" size="sm"></tt-icon><span class="tt-o-expander__text" v-html="$msg('commentsQuestion.showComments', [comments.length])"></span></tt-button>
      <tt-button ref="hideComments" v-show="showHide" type="toolbar" class="tt-c-question__actions-hide" @click="hideComments"
                                                                          aria-expanded="true">
        <tt-icon name="options-collapse" size="sm"></tt-icon><span class="tt-o-expander__text" v-html="$msg('commentsQuestion.hideComments')"></span></tt-button>
    </div>
  </div>
</div>
